import { bootstrapApplication } from '@angular/platform-browser';
import { AdminRootComponent } from './app/admin.component';
import { adminAppConfig } from './app/admin.config';

bootstrapApplication(AdminRootComponent, adminAppConfig);